
    import '/Users/lijixiang/Work/power-design/site/docs/changelog/flow-components.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/changelog/flow-components.md?type=demo')
};